// extracted by mini-css-extract-plugin
export default {"button":"Login_button__WzI3N"};